/* @flow */

import type { TranslatorProps } from 'react-i18next';
import to from 'to-case';

const statuses = {
  active: true,
  allocated: true,
  approved: true,
  archived: true,
  arrived: true,
  assigned: true,
  asset_dispatched: true,
  asset_unavailable: true,
  available: true,
  available_for_hire: true,
  awaiting_parts: true,
  beyond_economic_repair: true,
  built: true,
  cancelled: true,
  close: true,
  closed: true,
  collection_arranged: true,
  confirmed: true,
  conversion_of_null_status: true,
  conversion_of_tbs_status: true,
  created_in_value_delete: true,
  deferred_repair: true,
  deployed: true,
  disabled: true,
  disposed: true,
  ended: true,
  enabled: true,
  external_calibration: true,
  external_repair: true,
  external_service: true,
  faulty: true,
  in_repair: true,
  in_test: true,
  in_test_: true,
  in_test_new_asset: true,
  in_transit: true,
  in_use: true,
  in_use_in_canada: true,
  in_use_in_canada_: true,
  in_use_in_us: true,
  in_use_in_us_: true,
  inbound: true,
  inactive: true,
  inter_co_sale: true,
  internal_calibration: true,
  internal_repair: true,
  internal_service: true,
  internal_transfer: true,
  internal_use: true,
  lost: true,
  missing_accessories: true,
  mixed: true,
  new: true,
  not_approved: true,
  not_in_use: true,
  not_new: true,
  on_demo: true,
  on_hire: true,
  on_lease: true,
  lease: true,
  on_loan_to_us: true,
  on_rent: true,
  open: true,
  operating_lease: true,
  ordered: true,
  out_on_loan: true,
  outside_repair: true,
  owned: true,
  pending_review: true,
  planned: true,
  prepared: true,
  present: true,
  purchase_order_cancelled: true,
  quarantine: true,
  reinstated_from_write_off: true,
  rejected: true,
  rejected_by_lab: true,
  demo: true,
  rental: true,
  requires_check: true,
  reserved: true,
  retd_to_lending_co_: true,
  return_notified: true,
  returned: true,
  returned_from_borrower: true,
  returned_to_lending_company: true,
  retd_from_borrower: true,
  retd_to_lending_co: true,
  returned_to_vendor: true,
  sale: true,
  sales: true,
  scheduled: true,
  scheduled_for_repair: true,
  service_on_rent: true,
  sold: true,
  storage: true,
  sub_rental: true,
  temporary_exchange: true,
  to_be_shipped: true,
  transferred_to_inventory: true,
  unavailable: true,
  unknown: true,
  used_in_value_add: true,
  used_in_value_delete: true,
  written_off: true,
};

export type Status = $Keys<typeof statuses>;

export const getCode = (status: ?string): ?Status => {
  const code = to.snake(String(status));

  if (statuses[code]) {
    return code;
  }

  console.warn(`Status Code '${String(status)}', mapped to '${code}', not recognised.`);
};

export const getI18nCode = (status: string) => {
  const code = getCode(status);

  if (code) {
    return { code: `general:status.${code}`, exists: true };
  }

  return { code: status, exists: false };
};

export const translate = (status: string, i18n: TranslatorProps): string => {
  const { code, exists } = getI18nCode(status);

  if (exists) {
    return i18n.t(code);
  }

  return to.title(code);
};
